module.exports = __webpack_public_path__ + "img/08-osm-solicitacoes-lista.1f32e9bc.png";